import Layout from '@/layout/Index.vue'

export default [
  {
    path: '/oiltankManage',
    meta: { title: '油罐信息管理' },
    component: Layout,
    redirect: '/oiltankManage/list',
    children: [
      {
        path: 'list',
        meta: { title: '油罐信息管理', activeMenu: '/oiltankManage' },
        component: () => import('@/views/oiltankmanage/OiltankManage.vue')
      },
      // {
      //   path: 'add',
      //   meta: {
      //     title: '新增油罐信息',
      //     activeMenu: '/oiltankManage'
      //   },
      //   component: () => import('@/views/oiltankmanage/OiltankManageAdd.vue')
      // },
      {
        path: 'edit',
        meta: {
          title: '编辑油罐信息',
          activeMenu: '/oiltankManage'
        },
        component: () => import('@/views/oiltankmanage/OiltankManageAdd.vue')
      },
      {
        path: 'detail',
        meta: {
          title: '油罐信息详情',
          activeMenu: '/oiltankManage'
        },
        component: () => import('@/views/oiltankmanage/OiltankManageDetail.vue')
      }

    ]
  }
]
